export class ListVaultsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "VaultsFilterConditions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListVaultsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
